<script setup>
import {Theme} from "@/composables/theming";

import { defineProps } from 'vue'

defineEmits(['updateProgram', 'deleteProgram'])

defineProps({
  program: { type: Object, required: true },
})

</script>

<template>
  <div class="d-flex align-items-center border border-gray-300 rounded min-w-750px px-7 py-5 mb-5">
    <div class="col-md-5 pe-2">
      <span v-html="program.title"></span>
    </div>
    <div class="col-md-4   ">
      <span class="fs-2">{{ program.start_time }} - {{ program.end_time }}</span>
    </div>
    <div class="col-md-3 text-end  ">
      <a @click.prevent="$emit('updateProgram', program)" class="btn btn-sm btn-clean btn-icon" :title="$t('events.planning.qrcode')">
        <i class="fas fa-edit fs-2" :style="{ color: Theme.gray }"></i>
      </a>
      <a @click.prevent="$emit('deleteProgram', program)" class="btn btn-sm btn-clean btn-icon" :title="$t('button.show')">
        <i class="fas fa-trash fs-2" :style="{ color: Theme.gray }"></i>
      </a>
    </div>
  </div>

</template>

<style scoped>

</style>